import { Component, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { AppConfiguration } from '../../../app.configuration';

@Component({
	selector: '[layout-menu]',
	templateUrl: './menu.component.html',
	imports: [NgOptimizedImage, TranslateModule]
})
export class MenuComponent {
	private config = inject(AppConfiguration);
	assetsPath = this.config.appRootUrl;
}
